import React from 'react';
import PropTypes from 'prop-types';
import { formatClassName as _formatClassName } from '../../../../utils/formatClassName.js';
/** wraps a list of cards for propper formatting */

var CardsList = function CardsList(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: _formatClassName(['cards-list', className])
  }, children);
};

CardsList.displayName = "CardsList";
CardsList.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};
export { CardsList };